import { LoadingButton } from "@mui/lab";
import { Alert, Grid, InputAdornment, Stack, TextField } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import * as yup from "yup";

const validation = yup.object({
  first_name: yup.string().required("First name required"),
  last_name: yup.string().required("Last name required"),
  employee_id: yup.string(),
  secondary_phone: yup
    .string("Secondary phone")
    .min(10, "Must be exactly 10 digits")
    .max(10, "Must be exactly 10 digits"),
  location: yup.string("Location"),
  address: yup.string("address"),
  photo: yup.mixed("Add an image").nullable(),
});

const UserCommonProfile = ({
  userProfile,
  onSubmit,
  loading,
  errorMessage,
  error,
  success,
}) => {
  useEffect(() => {
    if (errorMessage) {
      Object.keys(errorMessage).forEach((key) => {
        console.log(key, errorMessage[key][0]);
        formik.setFieldError(key, errorMessage[key][0]);
      });
    }
  }, [errorMessage]);
  const formik = useFormik({
    initialValues: {
      first_name: userProfile?.first_name ?? "",
      last_name: userProfile?.first_name ?? "",
      employee_id: userProfile?.employee_id ?? "",
      secondary_phone: userProfile?.secondary_phone
        ? userProfile.secondary_phone.slice(3, 13)
        : "",
      location: userProfile?.location ?? "",
      address: userProfile?.address ?? "",
      photo: null,
    },
    validationSchema: validation,
    onSubmit: (data) => {
      onSubmit({
        ...data,
        secondary_phone: data.secondary_phone
          ? `+91${data.secondary_phone}`
          : null,
      });
    },
    validateOnChange: false,
  });

  return (
    <Grid container>
      <Grid item xs={12} md={userProfile ? 6 : 12} lg={userProfile ? 4 : 12}>
        <Stack direction="column" margin={userProfile ? 2 : 0}>
          <form onSubmit={formik.handleSubmit}>
            <TextField
              label="First name"
              variant="outlined"
              name="first_name"
              fullWidth
              sx={{ mt: 1.5 }}
              value={formik.values.first_name}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.first_name)}
              helperText={formik.errors.first_name}
              autoComplete="new-password"
              required
            />
            <TextField
              label="Last name"
              variant="outlined"
              name="last_name"
              fullWidth
              sx={{ mt: 1.5 }}
              value={formik.values.last_name}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.last_name)}
              helperText={formik.errors.last_name}
              autoComplete="new-password"
              required
            />

            <TextField
              label="Employee id"
              variant="outlined"
              name="employee_id"
              fullWidth
              sx={{ mt: 1.5 }}
              value={formik.values.employee_id}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.employee_id)}
              helperText={formik.errors.employee_id}
              autoComplete="new-password"
            />
            <TextField
              label="Secondary phone"
              variant="outlined"
              name="secondary_phone"
              inputProps={{
                maxLength: 10,
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">+91</InputAdornment>
                ),
              }}
              fullWidth
              sx={{ mt: 1.5 }}
              value={formik.values.secondary_phone}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.secondary_phone)}
              helperText={formik.errors.secondary_phone}
              autoComplete="new-password"
              type="tel"
            />
            <TextField
              label="Location"
              variant="outlined"
              name="location"
              fullWidth
              sx={{ mt: 1.5 }}
              value={formik.values.location}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.location)}
              helperText={formik.errors.location}
              autoComplete="new-password"
              required
            />
            <TextField
              label="Address"
              variant="outlined"
              name="address"
              fullWidth
              sx={{ mt: 1.5 }}
              value={formik.values.address}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.address)}
              helperText={formik.errors.address}
              autoComplete="new-password"
              multiline
              rows={5}
            />
            {error && (
              <Alert sx={{ my: 1 }} severity="error">
                Error occurred
              </Alert>
            )}

            {success && (
              <Alert sx={{ my: 1 }} severity="success">
                Success
              </Alert>
            )}
            <LoadingButton
              loading={loading}
              variant="contained"
              type="submit"
              sx={{ paddingX: 10, marginTop: 2 }}
            >
              {userProfile ? "Update" : "Save"}
            </LoadingButton>
          </form>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default UserCommonProfile;
